<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';
import OFFICE_STATE from '@organisms/offer/office-state-enum';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const state = computed(() => props.offer.state);

const cleanState = computed(() => {
  if (state.value.includes('setup_')) {
    return 'setup';
  }
  const validStates = [ OFFICE_STATE.PUBLISHED, OFFICE_STATE.UNPUBLISHED, OFFICE_STATE.BLOCKED, OFFICE_STATE.MODERATION, OFFICE_STATE.OFFMARKET, OFFICE_STATE.EXPIRED ];
  return validStates.includes(state.value) ? state.value : null;
});

const show = computed(() => !!cleanState.value);
</script>
<template>
  <span v-if="show" class="hit-label hit-label--state" :class="`hit-label--state_${cleanState}`">
    {{ trans(`offer.label.${cleanState}`) }}
  </span>
</template>
